module.exports = __webpack_public_path__ + "img/device-12.97c0c497.png";